function initializeAddressAutocomplete(inputId, options) {
  const element = document.getElementById(inputId);

  if (!element) return;

  const autocompleteOptions = {
    fields: ["address_components"],
    types: ["address"],
  };

  const autocomplete = new google.maps.places.Autocomplete(element, autocompleteOptions);
  google.maps.event.addListener(autocomplete, 'place_changed', function() {
    onPlaceChanged(this, options);
  });
}

function onPlaceChanged(autocomplete, options) {
  const place = autocomplete.getPlace();
  let streetNumber = '';
  let route = '';

  for (const component of place.address_components) {
    for (const type of component.types) {
      switch (type) {
        case 'street_number':
          streetNumber = component.long_name;
          break;
        case 'route':
          route = component.long_name;
          break;
        case 'locality': {
          const cityElement = document.querySelector(options.citySelector);
          if (cityElement) cityElement.value = component.long_name;
          break;
        }
        case 'postal_code': {
          const postalCodeElement = document.querySelector(options.postalCodeSelector);
          if (postalCodeElement) postalCodeElement.value = component.short_name;
          break;
        }
        case 'country': {
          const countryElement = document.querySelector(options.countrySelector);
          if (countryElement) countryElement.value = component.short_name;
          break;
        }
      }
    }
  }

  const addressField = document.querySelector(options.addressSelector);
  if (addressField) {
    addressField.value = [streetNumber, route].filter(Boolean).join(' ');
  }
}

if (typeof google !== 'undefined') {
  google.maps.event.addDomListener(window, 'load', function () {
    initializeAddressAutocomplete('user_input_autocomplete_address', {
      addressSelector: '.address-field',
      citySelector: '.city',
      postalCodeSelector: '.postal-code',
      countrySelector: '.country'
    });

    initializeAddressAutocomplete('legal_entity_input_autocomplete_address', {
      addressSelector: '.legal-entity-address-field',
      citySelector: '.legal-entity-city',
      postalCodeSelector: '.legal-entity-postal-code',
      countrySelector: '.legal-entity-country'
    });
  });
}
